import { render, staticRenderFns } from "./LiveQuizLobby.vue?vue&type=template&id=33862af4&scoped=true"
import script from "./LiveQuizLobby.vue?vue&type=script&lang=js"
export * from "./LiveQuizLobby.vue?vue&type=script&lang=js"
import style0 from "./LiveQuizLobby.vue?vue&type=style&index=0&id=33862af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33862af4",
  null
  
)

export default component.exports